import { render, staticRenderFns } from "./Legales.vue?vue&type=template&id=d5d73fd8&scoped=true&"
import script from "./Legales.vue?vue&type=script&lang=js&"
export * from "./Legales.vue?vue&type=script&lang=js&"
import style0 from "./Legales.vue?vue&type=style&index=0&id=d5d73fd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d73fd8",
  null
  
)

export default component.exports